var _style, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxsFileExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-587 439 24 24",
    style: {
      enableBackground: "new -587 439 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7C7B7B;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1160,880h-8c-1.1,0-2,0.9-2,2v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-12L-1160,880z M-1160,887h-1v-5l5,5 H-1160z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1168.583 896.3747)",
    className: "st1",
    style: {
      fontFamily: "'Poppins-Bold'",
      fontSize: 10
    }
  }, "X"), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1160.3,
    y: 890.6,
    className: "st1",
    width: 1.8,
    height: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1157.4,
    y: 892.2,
    className: "st1",
    width: 1.8,
    height: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1158,
    y: 890.6,
    className: "st1",
    width: 2.4,
    height: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -1160.2,
    y: 893.6,
    className: "st1",
    width: 1.8,
    height: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -1157.9,
    y: 893.6,
    className: "st1",
    width: 2.4,
    height: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -1160.3,
    y: 892.2,
    className: "st1",
    width: 2.4,
    height: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsFileExcel);
export default __webpack_public_path__ + "static/media/bxs-file-excel.41fad357815b7cf523289f037d4cabc6.svg";
export { ForwardRef as ReactComponent };